import {
  TCreateReferenceDetectionDto,
  ISubmitReferenceDetectionDto,
  IReferenceDetectionRun,
} from '../types/references.types';
import { makeDetectionApiHooks } from './shared.api';
import { TERMINOLOGY } from '@shared/i18n';

// Build once; export typed hooks
const { useCreateDetection, usePollDetection, useSubmitDetection, useCancelDetection } = makeDetectionApiHooks<
  TCreateReferenceDetectionDto,
  IReferenceDetectionRun,
  ISubmitReferenceDetectionDto
>({
  ns: 'references',
  basePath: '/detections/references',
  messages: {
    startedSuccess: `${TERMINOLOGY.reference.upper} detection run started.`,
    startError: `Failed to start ${TERMINOLOGY.reference.lower} detection!`,
    lockedWarning: 'Some documents are locked by other users.',

    submitSuccess: `${TERMINOLOGY.reference.upperPlural} submitted.`,
    submitError: `Failed to submit ${TERMINOLOGY.reference.lowerPlural}!`,

    cancelSuccess: `${TERMINOLOGY.reference.upper} detection run cancelled.`,
    cancelError: `Failed to cancel ${TERMINOLOGY.reference.lower} detection run!`,

    loadErrorTitle: `Failed to load ${TERMINOLOGY.reference.lower} detection run!`,
    loadErrorToast: `Loading ${TERMINOLOGY.reference.lower} detection failed!`,
  },
});

export const useCreateReferenceDetection = useCreateDetection;
export const usePollReferenceDetection = usePollDetection;
export const useSubmitReferenceDetection = useSubmitDetection;
export const useCancelReferenceDetection = useCancelDetection;
